import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import history from '../../history'

import { Container, Fab, Grid } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import EditarVagasForm from './components/EditarVagasForm'
import { postUpdateVaga } from '../../serviceAPI/postUpdateVaga'

function EditarVaga(props) {
    const dispatch = useDispatch();
    const cidadeSelecionada = useSelector(state => state.cidades.cidadeSelecionada)
    const uf = useSelector(state => state.cidades.uf)
    const vaga = props.location.state;

    React.useEffect(() => {
        if (!props.location.state) {
            history.replace("gerenciar-vagas")
        }
    }, [])

    async function atualizarVaga(id, cargo, pcd, atividades, requisitos, salarioMin, salarioMax,
        beneficios, regime, numeroVagas, vigenciaVaga, confidencial) {
        await postUpdateVaga(id, cargo, pcd, atividades, requisitos, salarioMin, salarioMax, beneficios,
            regime, numeroVagas, vigenciaVaga, confidencial, uf, cidadeSelecionada, dispatch)

    }

    function voltar() {
        history.replace("gerenciar-vagas");
    }

    return (
        <>
            <Container maxWidth="md">
                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                >
                    <Fab
                        style={{ marginTop: 20 }}
                        color="secondary"
                        aria-label="goBack"
                        onClick={() => voltar()}>
                        <ArrowBackIcon />
                    </Fab>
                </Grid>
                <div>
                    <EditarVagasForm vaga={vaga} onsubmit={atualizarVaga} />
                </div>
            </Container>

        </>
    )
}

export default EditarVaga;